export default {
  "Contains the street, city, zip, and state associated with an address.":
    "Contiene la calle, ciudad, código postal y estado asociados con una dirección.",
  "Contains the street number and name":
    "Contiene el número y nombre de la calle",
  "Contains the additional street address information such as suite or apartment":
    "Contiene información adicional de la dirección como suite o apartamento",
  City: "Ciudad",
  County: "Condado",
  State: "Estado",
  "Zip code": "Código postal",
  "Contact information including phone numbers and email address.":
    "Información de contacto incluyendo números de teléfono y dirección de correo electrónico.",
  "The coverages rated on the policy.":
    "Las coberturas calificadas en la póliza.",
  "Bodily injury liability coverage helps pay for another person's expenses if you injure them in a car accident.":
    "La cobertura de responsabilidad civil por lesiones corporales ayuda a pagar los gastos de otra persona si la lesiona en un accidente automovilístico.",
  "Property damage liability coverage helps pay for damage you cause to another person's vehicle or property.":
    "La cobertura de responsabilidad civil por daños a la propiedad ayuda a pagar por los daños que cause al vehículo o propiedad de otra persona.",
  "Medical payments coverage may help pay your or your passengers' medical expenses if you're injured in a car accident":
    "La cobertura de pagos médicos puede ayudar a pagar sus gastos médicos o los de sus pasajeros si resultan heridos en un accidente automovilístico",
  "Uninsured motorist BI insurance protects you if you're in an accident with an at-fault driver who doesn't carry liability insurance.":
    "El seguro de motorista sin seguro BI lo protege si está en un accidente con un conductor culpable que no tiene seguro de responsabilidad civil.",
  "Uninsured motorist PD insurance protects you if you're in an accident with an at-fault driver who doesn't carry liability insurance.":
    "El seguro de motorista sin seguro PD lo protege si está en un accidente con un conductor culpable que no tiene seguro de responsabilidad civil.",
  "Accidental death and dismemberment (AD&D) is a policy that pays benefits to the beneficiary if the cause of death is an accident.":
    "Muerte accidental y desmembramiento (AD&D) es una póliza que paga beneficios al beneficiario si la causa de muerte es un accidente.",
  "The coverages rated on the vehicle.":
    "Las coberturas calificadas en el vehículo.",
  "Collision insurance is a coverage that helps pay to repair or replace your car if it's damaged in an accident with another vehicle or object, such as a fence or a tree.":
    "El seguro de colisión es una cobertura que ayuda a pagar la reparación o reemplazo de su automóvil si resulta dañado en un accidente con otro vehículo u objeto, como una cerca o un árbol.",
  "Comprehensive insurance is a coverage that helps pay to replace or repair your vehicle if it's stolen or damaged in an incident that's not a collision.":
    "El seguro integral es una cobertura que ayuda a pagar el reemplazo o la reparación de su vehículo si es robado o dañado en un incidente que no sea una colisión.",
  "The vehicle's custom equipment value.":
    "El valor del equipo personalizado del vehículo.",
  "Gap insurance is coverage that helps pay off your auto loan if your car is totaled or stolen and you owe more than the car's depreciated value.":
    "El seguro Gap es una cobertura que ayuda a pagar su préstamo de auto si su automóvil es pérdida total o es robado y usted debe más que el valor depreciado del automóvil.",
  "Rental Reimbursement helps pay your rental car costs while your car is being repaired as a result of a covered claim.":
    "El reembolso de alquiler ayuda a pagar los costos de un auto de alquiler mientras su automóvil está siendo reparado como resultado de un reclamo cubierto.",
  "Roadside assistance typically protects you against some of the costs and hassles associated with common roadside breakdowns like dead batteries, flat tires or being locked out of your car.":
    "La asistencia en carretera normalmente lo protege contra algunos de los costos y molestias asociados con averías comunes en carretera como baterías descargadas, llantas pinchadas o quedarse encerrado fuera de su automóvil.",
  "Safety coverage.": "Cobertura de seguridad.",
  "The named insured on the quote.": "El asegurado nombrado en la cotización.",
  "A tracking identifier provided by the API consumer.":
    "Un identificador de seguimiento proporcionado por el consumidor de la API.",
  "The customer's first name.": "El nombre del cliente.",
  "The customer's middle name.": "El segundo nombre del cliente.",
  "The customer's last name.": "El apellido del cliente.",
  "Did this customer decline to submit an email address?":
    "¿Este cliente declinó proporcionar una dirección de correo electrónico?",
  "Did this customer decline to submit a phone number?":
    "¿Este cliente declinó proporcionar un número de teléfono?",
  "Customer's' address.": "Dirección del cliente.",
  "Customer's prior address.": "Dirección anterior del cliente.",
  "The customer's contact information'.":
    "La información de contacto del cliente.",
  "The number of months the customer has been at the current residence.":
    "El número de meses que el cliente ha vivido en la residencia actual.",
  "Did this customer decline to have his credit score run?":
    "¿Este cliente declinó que se verificara su puntaje de crédito?",
  "The number of residents in the current residence.":
    "El número de residentes en la residencia actual.",
  "The customer's current insurance information.":
    "La información del seguro actual del cliente.",
  "Contains the discount information of the driver.":
    "Contiene la información de descuentos del conductor.",
  "Apply a distant student discount?":
    "¿Aplicar descuento de estudiante distante?",
  "Apply a driver's training discount?":
    "¿Aplicar descuento de entrenamiento de conductores?",
  "Apply a good student discount?": "¿Aplicar descuento de buen estudiante?",
  "Apply a single parent discount?":
    "¿Aplicar descuento de padre/madre soltero(a)?",
  "Apply a accident prevention course discount?":
    "¿Aplicar descuento por curso de prevención de accidentes?",
  "The date the accident prevention course was taken by the driver.":
    "La fecha en que el conductor tomó el curso de prevención de accidentes.",
  "Apply a senior driver discount?": "¿Aplicar descuento de conductor senior?",
  "The date the senior driving course was taken by the driver.":
    "La fecha en que el conductor tomó el curso de conducción para seniors.",
  "Does the driver have other policies with rating company?":
    "¿El conductor tiene otras pólizas con la compañía calificadora?",
  "Companion policy information such as line of business, issuer, and policy number":
    "Información de la póliza complementaria como línea de negocio, emisor y número de póliza",
  "A rated or excluded driver on the quote.":
    "Un conductor calificado o excluido en la cotización.",
  "The id of the driver.  The first driver must have a value of 1.":
    "El identificador del conductor. El primer conductor debe tener un valor de 1.",
  "The driver's first name.": "El nombre del conductor.",
  "The driver's middle name.": "El segundo nombre del conductor.",
  "The driver's last name.": "El apellido del conductor.",
  "The driver's date of birth.": "La fecha de nacimiento del conductor.",
  "The driver's gender.": "El género del conductor.",
  "The driver's marital status.": "El estado civil del conductor.",
  "The number of months the driver has been employed.":
    "El número de meses que el conductor ha estado empleado.",
  "The driver's occupation.": "La ocupación del conductor.",
  "The driver's license information.":
    "La información de licencia del conductor.",
  "The driver's attributes.": "Los atributos del conductor.",
  "The driver discounts.": "Los descuentos del conductor.",
  "The driver's financial responsibility filings.":
    "Los archivos de responsabilidad financiera del conductor.",
  "The driver's violations.": "Las infracciones del conductor.",
  "The driver's education level.": "El nivel educativo del conductor.",
  "Is the driver an occasional operator of his vehicle?":
    "¿El conductor es un operador ocasional de su vehículo?",
  "Does this driver have property insurance?":
    "¿Este conductor tiene seguro de propiedad?",
  "What is the relation of this driver to the named insured?":
    "¿Cuál es la relación de este conductor con el asegurado nombrado?",
  "Does this driver own, rent, or lease his residence?":
    "¿Este conductor es propietario, alquila o arrienda su residencia?",
  "The type of residence the driver lives in.":
    "El tipo de residencia en la que vive el conductor.",
  "How many miles does the driver drive to work each day?":
    "¿Cuántas millas conduce el conductor al trabajo cada día?",
  "Driver's license information.": "Información de la licencia de conducir.",
  "The license status of the driver.":
    "El estado de la licencia del conductor.",
  "Driver's license number": "Número de licencia de conducir",
  "The number of months the driver has had a foreign license.":
    "El número de meses que el conductor ha tenido una licencia extranjera.",
  "The number of months the driver has been licensed.":
    "El número de meses que el conductor ha tenido licencia.",
  "The number of months the driver has been licensed in the rating state.":
    "El número de meses que el conductor ha tenido licencia en el estado calificador.",
  "The number of months of MVR experience the driver has.":
    "El número de meses de experiencia MVR que tiene el conductor.",
  "The number of months the driver has been suspended.":
    "El número de meses que el conductor ha estado suspendido.",
  "The state the driver is licensed in.":
    "El estado en el que el conductor tiene licencia.",
  "What kind of foreign license does the driver have?":
    "¿Qué tipo de licencia extranjera tiene el conductor?",
  "Is this driver a foreign national?": "¿Este conductor es extranjero?",
  "Does this driver have an international driver's license?":
    "¿Este conductor tiene una licencia de conducir internacional?",
  "Information about the financial responsibility filing of the driver.":
    "Información sobre el archivo de responsabilidad financiera del conductor.",
  "Does this driver require an SR-22?": "¿Este conductor requiere un SR-22?",
  "The reason for the financial responsibility filing.":
    "La razón del archivo de responsabilidad financiera.",
  "The financial responsibility filing state.":
    "El estado del archivo de responsabilidad financiera.",
  "The financial responsibility filing date.":
    "La fecha del archivo de responsabilidad financiera.",
  "The financial responsibility filing case number.":
    "El número de caso del archivo de responsabilidad financiera.",
  "The lienholder information associated with a vehicle.":
    "La información del acreedor asociada con un vehículo.",
  "The name of the lienholder.": "El nombre del acreedor.",
  "The address associated with the lienholder.":
    "La dirección asociada con el acreedor.",
  "Is this a loan or a lease?": "¿Es un préstamo o un arriendo?",
  "An agency fee to be tacked on the quote.":
    "Una tarifa de agencia que se añadirá a la cotización.",
  "The amount of the fee.": "El monto de la tarifa.",
  "Should this fee be applied to the down payment?":
    "¿Esta tarifa debe aplicarse al pago inicial?",
  "The description of the fee?": "¿La descripción de la tarifa?",
  "The amount based on total premium amount.":
    "El monto basado en el monto total de la prima.",
  "Should this fee be applied to the quote, each driver, or each vehicle?":
    "¿Esta tarifa debe aplicarse a la cotización, a cada conductor o a cada vehículo?",
  "Phone number extension": "Extensión de número telefónico",
  "Contains the prior insurance information of the customer.":
    "Contiene la información del seguro anterior del cliente.",
  "Was the prior insurance policy written in your agency?":
    "¿La póliza de seguro anterior fue emitida en esta agencia?",
  "The id of the prior carrier.":
    "El identificador de la aseguradora anterior.",
  "The name of the prior carrier.": "El nombre de la aseguradora anterior.",
  "The date the prior insurance policy expires.":
    "La fecha en que vence la póliza de seguro anterior.",
  "Does this customer currently have insurance?":
    "¿Este cliente actualmente tiene seguro?",
  "Prior carrier liability coverage.":
    "Cobertura de responsabilidad del transportista anterior.",
  "The number of months of prior insurance for the customer.":
    "El número de meses de seguro anterior para el cliente.",
  "The reason the customer currently does not have insurance.":
    "La razón por la que el cliente actualmente no tiene seguro.",
  "US state.": "Estado de EE. UU.",
  "A vehicle on the quote.": "Un vehículo en la cotización.",
  "The id of the vehicle.  The first vehicle must have a value of 1.":
    "El identificador del vehículo. El primer vehículo debe tener un valor de 1.",
  "The vehicle's actual cash value.": "El valor real en efectivo del vehículo.",
  "The vehicle's annual miles.": "Las millas anuales del vehículo.",
  "The id of the driver assigned to this vehicle.":
    "El identificador del conductor asignado a este vehículo.",
  "Is this a gray market vehicle?": "¿Es este un vehículo de mercado gris?",
  "Does this vehicle have a homing device?":
    "¿Este vehículo tiene un dispositivo de localización?",
  "Does this vehicle have a hood lock?":
    "¿Este vehículo tiene cerradura de capó?",
  "Is this vehicle leased?": "¿Este vehículo está arrendado?",
  "The vehicle's license plate number.'": "El número de placa del vehículo.",
  "The list of lienholders for this vehicle.":
    "La lista de acreedores para este vehículo.",
  "The vehicle's miles to work each day.":
    "Las millas del vehículo al trabajo cada día.",
  "The vehicle's odometer reading.": "La lectura del odómetro del vehículo.",
  "The percentage of this vehicle's driving amount that is spent driving to work.":
    "El porcentaje de conducción de este vehículo que se dedica a ir al trabajo.",
  "The purchase cost of the vehicle.": "El costo de compra del vehículo.",
  "The date the vehicle was purchased.'":
    "La fecha en que se compró el vehículo.",
  "Was this vehicle purchased new or used?":
    "¿Este vehículo se compró nuevo o usado?",
  "Is this vehicle used for ride sharing?":
    "¿Este vehículo se usa para viajes compartidos?",
  "Has this vehicle been salvaged?": "¿Este vehículo ha sido recuperado?",
  "How is this vehicle used?": "¿Cómo se usa este vehículo?",
  "Does the client agree to use a device or an app to monitor this vehicle's usage?":
    "¿El cliente acepta usar un dispositivo o una aplicación para monitorear el uso de este vehículo?",
  VIN: "VIN",
  "Does this vehicle have VIN etching?": "¿Este vehículo tiene grabado de VIN?",
  "A motor vehicle violation.": "Una infracción de vehículo motorizado.",
  "Violation attributes (1). The meaning of each attribute varies by violation code":
    "Atributos de infracción (1). El significado de cada atributo varía según el código de infracción",
  "Violation attributes (2). The meaning of each attribute varies by violation code":
    "Atributos de infracción (2). El significado de cada atributo varía según el código de infracción",
  "The violation code.": "El código de la infracción.",
  "The date the violation occurred.": "La fecha en que ocurrió la infracción.",
  "Did this violation occur on the same day as another violation?":
    "¿Esta infracción ocurrió el mismo día que otra infracción?",
  "Control bumping of invalid coverages.":
    "Control de aumento de coberturas inválidas.",
  "The carriers to be rated.": "Las aseguradoras a ser calificadas.",
  "Use the credentials passed for each CarrierInfo?":
    "¿Usar las credenciales proporcionadas para cada CarrierInfo?",
  "The list of products to rate for the request":
    "La lista de productos a calificar para la solicitud",
  "The specific rating product for the carrier":
    "El producto de calificación específico para la aseguradora",
  "The specific agency identifier": "El identificador específico de la agencia",
  "The specific product's carrier identifier'":
    "El identificador de la aseguradora del producto específico",
  "The specific product's carrier name'":
    "El nombre de la aseguradora del producto específico",
  "The specific product's identifier'":
    "El identificador del producto específico",
  "The identifier for the product's program.'":
    "El identificador para el programa del producto.",
  "The specific product's name'": "El nombre del producto específico",
  "The custom underwriting questions required to rate this product.  Each product will have it's own schema for validation.":
    "Las preguntas personalizadas de suscripción requeridas para calificar este producto. Cada producto tendrá su propio esquema para validación.",
  "The product's producer code": "El código de productor del producto",
  "The product's sub producer code": "El código de subproductor del producto",
  "The product's username": "El nombre de usuario del producto",
  "The product's password": "La contraseña del producto",
  "An identifier supplied by the carrier for purposes of re-rating a quote":
    "Un identificador proporcionado por la aseguradora para fines de recalificación de una cotización",
  "The customer associated with the quote.":
    "El cliente asociado con la cotización.",
  "The policy type of the quote.": "El tipo de póliza de la cotización.",
  "The policy level coverages associated with the quote.":
    "Las coberturas a nivel de póliza asociadas con la cotización.",
  "All miscellaneous agency fees tacked on the quote.":
    "Todas las tarifas misceláneas de la agencia añadidas a la cotización.",
  "The rated drivers on the quote.":
    "Los conductores calificados en la cotización.",
  "The excluded drivers on the quote.":
    "Los conductores excluidos en la cotización.",
  "The vehicles on the quote.": "Los vehículos en la cotización.",
  "The term on the quote.": "El plazo en la cotización.",
  "The payment method on the quote.": "El método de pago en la cotización.",
  "The requested number of payments.": "El número de pagos solicitados.",
  "The requested down payment percenage.":
    "El porcentaje de pago inicial solicitado.",
  "Should a paperless discount be applied to this quote?":
    "¿Se debe aplicar un descuento sin papel a esta cotización?",
  "Optional filter for pay plans.": "Filtro opcional para planes de pago.",
  "Optional filter for agency bill.":
    "Filtro opcional para factura de agencia.",
  "The effective date of the quote.": "La fecha efectiva de la cotización.",
  "The list of carriers on the request.":
    "La lista de aseguradoras en la solicitud.",
};
